// extracted by mini-css-extract-plugin
export default {"valueWarning":"ScheduleTypeProgressCard_valueWarning__dcTUq"};